import { motion } from 'framer-motion';

const TestimonialHero = () => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0df50309e07a0bfa5e8ee06360e96c24.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/85 to-white/90"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            お客様の声
          </h1>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            赤石会計事務所をご利用いただいているお客様からいただいた声をご紹介します
          </p>
          <a
            href="/#contact"
            className="inline-flex items-center gap-2 bg-red text-white px-10 py-4 rounded-full text-[15px] font-medium hover:bg-red-dark transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <span>無料相談を予約する</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialHero;
